import { Route } from "react-router-dom";
import { CliAuthorizePage } from "@components/cliAuthorize/CliAuthorizePage";

export const useRenderCliAuthorizeRoute = () => (
    <Route path="/cli-authorize" element={<CliAuthorizePage />} />
);
